export default "NATO Frigate with refuelling possibilities in the vicinity.\nNo Helicopter is available due to maintenance.";